import styled from 'styled-components';
import '../../containers/BoxContainer';
import BoxContainer from '../../containers/BoxContainer';
import {Wrapper as CountdownContainer} from 'components/Countdown';
import {transparentize} from 'polished';

export const Wrapper = styled.div`
  width: 100%;
  height: 480px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  box-sizing: border-box;
  padding: 40px;
  
  border-radius: 5px;
  background-color: #232323;
  background-image: url('/images/icons/webinar.svg');
  background-repeat: no-repeat;
  background-position: calc(100% + 55px) calc(100% + 66px);
`;

export const Title = styled.span`
  font-size: 46px;
  font-weight: 700;
  line-height: 60px;
`;

export const Content = styled(BoxContainer)`
  max-width: 240px;
  box-sizing: border-box;
  padding: 16px 20px;
  text-align: center;
`;

export const Countdown = styled.div`
  width: 100%;
  margin-top: 6px;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0.01em;
  text-align: center;
  
  ${CountdownContainer} {
    justify-content: center;
  }
`

export const Label = styled.span<{
  accent?: boolean;
}>`
  gap: 6px;
  display: grid;
  font-weight: ${({accent}) => accent ? '700' : '400'};
  font-size: ${({accent}) => accent ? '24px' : '14px'};
  color: ${({accent, theme}) => accent ? `
    ${theme.variables.color};
  ` : `
    ${transparentize(.6, theme.variables.color)};
  `};
`;
